import React, { createContext, useContext } from 'react';

const OverviewUserContext = createContext(null);

export const useOverviewUser = () => useContext(OverviewUserContext);

export const OverviewUserProvider = OverviewUserContext.Provider;
